import { NodeConnector } from 'ui/workflows/flowchart';
import { NODE_TYPES, OUTPUT_CONNECTORS_BY_TYPE } from '../../constants';
import { NodeData, NodeType } from '../../types';

export const CAMPAIGN_ID = 'campaignId';

export const parseOutputConnectors = (
  nodeData: Partial<NodeData>,
  nodeType: NodeType,
): NodeConnector[] => {
  switch (nodeType) {
    case NODE_TYPES.AB_SPLIT:
      return nodeData.splitGroups
        ? nodeData.splitGroups.map((sg: NodeData['splitGroups']) => ({
            name: `${+(sg.splitPercentage * 100).toFixed(1)}%`,
          }))
        : OUTPUT_CONNECTORS_BY_TYPE[NODE_TYPES.AB_SPLIT];

    case NODE_TYPES.ATTRIBUTE_SPLIT:
      return nodeData.splitValues != null
        ? nodeData.splitValues.map((sv: NodeData['splitValues']) => {
            const value = sv.value === '' ? '-' : sv.value;
            return { name: sv.isDefault ? 'Everyone else' : value };
          })
        : OUTPUT_CONNECTORS_BY_TYPE[NODE_TYPES.ATTRIBUTE_SPLIT];

    case NODE_TYPES.HOLD_UNTIL_REPLY: {
      const searchQueries = nodeData?.triggerRule?.searchQuery?.searchQueries;
      const searchQuery = searchQueries?.[0];
      const orSearchQuery = searchQueries?.[1];
      const searchQueryField = searchQuery?.field;

      const queries =
        searchQueryField === CAMPAIGN_ID
          ? orSearchQuery?.searchQueries
          : searchQuery?.searchQueries;

      const replies = (queries || []).filter((query: { value: string }) => query?.value !== '');

      return [
        ...replies.map((_reply: any, idx: number) => ({
          name: _reply?.values?.[0] || `Reply #${idx + 1}`,
        })),
        ...OUTPUT_CONNECTORS_BY_TYPE[NODE_TYPES.HOLD_UNTIL_REPLY],
      ];
    }
    default:
      return OUTPUT_CONNECTORS_BY_TYPE[nodeType];
  }
};
